import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=6a05726c&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=6a05726c&prod&lang=less&scoped=true"
import style1 from "./goods.vue?vue&type=style&index=1&id=6a05726c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a05726c",
  null
  
)

export default component.exports